import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/types';

interface ComicCardProps {
  comic: Comic;
  showRank?: boolean;
}

export default function ComicCard({ comic, showRank = false }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-100">
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 韩漫免费阅读`}
          title={`${comic.title} - 韩漫在线免费阅读`}
          loading="lazy"
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>

        {showRank && comic.rank <= 3 && (
          <span className="absolute top-2 right-2 px-2.5 py-1 text-xs font-bold whitespace-nowrap rounded-md bg-accent-500 text-background-50">
            TOP.{String(comic.rank).padStart(2, '0')}
          </span>
        )}

        {comic.isNew && !showRank && (
          <span className="absolute top-2 right-2 px-2 py-0.5 text-xs font-medium whitespace-nowrap rounded-md bg-accent-500 text-background-50">
            今日更新
          </span>
        )}
        {!comic.isNew && !showRank && (
          <span className={`absolute top-2 right-2 px-2 py-0.5 text-xs font-medium whitespace-nowrap rounded-md ${
            comic.status === 'ongoing' ? 'bg-secondary-500 text-background-50' : 'bg-foreground-400 text-background-50'
          }`}>
            {comic.status === 'ongoing' ? '连载中' : '已完结'}
          </span>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="text-sm md:text-base font-semibold text-background-50 leading-tight line-clamp-1">
            {comic.title}
          </h3>
          <p className="text-xs text-background-50/70 mt-1">
            {comic.isNew ? `第 ${comic.chapters.length} 话` : `更新至第 ${comic.chapters.length} 话`}
          </p>
          {showRank && (
            <div className="flex items-center gap-1 mt-1">
              <i className="ri-star-fill text-yellow-400 text-xs"></i>
              <span className="text-xs text-background-50/80">{comic.rating}</span>
              <span className="text-xs text-background-50/50 ml-1">{(comic.views / 10000).toFixed(0)}万阅读</span>
            </div>
          )}
        </div>
      </div>
    </Link>
  );
}